import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: [],
    active: []
};
function pairResource(data) {
    var broker = {
        id: data.broker.id,
        name: data.broker.name,
        separator: data.broker.separator,
        hasUniqueTradeId: data.broker.hasUniqueTradeId
    };
    return {
        id: data.id,
        name: data.name,
        baseCurrency: data.baseCurrency,
        quoteCurrency: data.quoteCurrency,
        maxSum: data.maxSum,
        broker: broker,
        restartMaxTimeValue: data.restartMaxTimeValue,
        minQuantity: data.minQuantity
    };
}
function accountOrderResource(data) {
    return {
        id: data.id,
        pairName: data.pairName,
        createdTime: data.createdTime * 1000,
        updatedTime: data.updatedTime * 1000,
        duration: data.duration,
        side: data.side,
        quantity: data.quantity,
        price: data.price,
        status: data.status
    };
}
export var AccountOrdersReducer = createSlice({
    name: 'accountOrders',
    initialState: initialState,
    reducers: {
        set: function set(state, accountOrders) {
            var data = [];
            accountOrders.payload.forEach(function (item) {
                data.push(accountOrderResource(item));
            });
            state.data = data;
        },
        setPairs: function setPairs(state, pairs) {
            var resource = [];
            pairs.payload.forEach(function (element) {
                resource.push(pairResource(element));
            });
            state.active = resource;
        },
        del: function del(state, id) {
            var index = state.data.findIndex(function (el) {
                return el.id === id.payload;
            });
            state.data.splice(index, 1);
        },
        delAll: function delAll(state) {
            state.data = [];
        }
    }
});
var _AccountOrdersReducer = AccountOrdersReducer.actions, set = _AccountOrdersReducer.set, setPairs = _AccountOrdersReducer.setPairs, del = _AccountOrdersReducer.del, delAll = _AccountOrdersReducer.delAll;
export { set, setPairs, del, delAll };
export default AccountOrdersReducer.reducer;
